import {useCallback, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {ChatRoomsEnum, GuidesEnum} from 'presentation/constants';
import {useAccountInformation} from './useAccountInformation';
import {useCallChatRoom} from './useCallChatRoom';
import {useQueryParams} from './useQueryParams';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

export function useNotFound() {
	const navigate = useNavigate();
	const {odontoOnly} = useAccountInformation();
	const {callChatRoom, IS_LOADING: chatRoomIsLoading} = useCallChatRoom();
	const {clearSearch} = useQueryParams();

	const [notFoundModalIsOpen, setNotFoundModalIsOpen] = useState(false);

	const handleCallChatRoom = useCallback(
		async (flowType?: FlowEnum) => {
			let type = ChatRoomsEnum.APP;

			if (flowType === FlowEnum.ODONTO) {
				type = ChatRoomsEnum.ODONTO;
			}

			if (flowType === FlowEnum.EXAM) {
				type = ChatRoomsEnum.EXAMS;
			}

			await callChatRoom(type);
			setNotFoundModalIsOpen(false);
		},
		[callChatRoom, setNotFoundModalIsOpen],
	);

	const handleGuideNav = useCallback(
		(flowType?: FlowEnum) => {
			let guideType = GuidesEnum.SERVICE_NETWORK_HEALTH;

			if (odontoOnly || flowType === FlowEnum.ODONTO) {
				guideType = GuidesEnum.SERVICE_NETWORK_ODONTO;
			}

			clearSearch();
			navigate(guideType);

			setNotFoundModalIsOpen(false);
		},
		[odontoOnly],
	);

	return {
		handleGuideNav,
		handleCallChatRoom,
		notFoundModalIsOpen,
		setNotFoundModalIsOpen,
		chatRoomIsLoading,
	};
}
